/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {UserProxiesCommandContract} from './contracts/user/user-proxies-command.contract';
import {UserDetailContract} from '../ms-security/contracts/user-detail.contract';
import {UserResultContract} from '../ms-security/contracts/user-result.contract';
import {UserProxyDetailContract} from './contracts/user/user-proxy-detail.contract';

@Injectable({
    providedIn: 'root'
})
export class UserApi {
    private userBaseUrl = `${environment.partNumberChangesBaseUrl}/api/user`;

    constructor(protected http: HttpClient) {
    }

    /**
     * This method returns all the proxies associated to a specific user
     */
    getUserProxies(): Observable<UserProxyDetailContract> {
        return this.http.get<UserProxyDetailContract>(`${this.userBaseUrl}/proxy`);
    }

    /**
     * This method adds proxies to a specific user
     * @param proxiesToAdd {@link UserProxiesCommandContract} of the proxies to add
     */
    addProxies(proxiesToAdd: UserProxiesCommandContract): Observable<void> {
        return this.http.put<void>(`${this.userBaseUrl}/proxy`, proxiesToAdd);
    }

    /**
     * This method removes the association between an user and a proxy
     * @param proxyUsername the username of the proxy to remove
     */
    deleteProxy(proxyUsername: string): Observable<void> {
        return this.http.delete<void>(`${this.userBaseUrl}/proxy/${proxyUsername}`);
    }

    /**
     * Retrieves the users detail from the BE
     * @param query the string to use as query value
     * @param excludedUsernames the usernames list of the proxies already associated with the user
     * @param firstResult index of the first result to retrieve
     * @param maxResults max number of results
     */
    getAutocompleteProxies(query: string,
                           excludedUsernames: string[] = [],
                           firstResult: number = 0,
                           maxResults: number = 20): Observable<UserResultContract<UserDetailContract>> {
        return this.http.post<UserResultContract<UserDetailContract>>(`${this.userBaseUrl}/proxy/search/detail`, {
            searchCriteria: {
                identification: query,
                excludedUsernames: excludedUsernames
            },
            paginationCriteria: {
                firstResult: firstResult,
                maxResults: maxResults,
                sortCriteria: [
                    {
                        criterion: 'FIRST_NAME',
                        sortDirection: 'ASC'
                    },
                    {
                        criterion: 'LAST_NAME',
                        sortDirection: 'ASC'
                    }
                ]
            }
        });
    }

}
